import { create } from "zustand";
import type { Service } from "../types/database";

interface ServicesState {
  services: Service[];
  selectedService: Service | null;

  setServices: (services: Service[]) => void;
  addService: (service: Service) => void;
  updateService: (id: string, updates: Partial<Service>) => void;
  removeService: (id: string) => void;
  setSelectedService: (service: Service | null) => void;
}

export const useServicesStore = create<ServicesState>((set) => ({
  services: [],
  selectedService: null,

  setServices: (services) => set({ services }),

  addService: (service) => set((state) => ({
    services: [service, ...state.services],
  })),

  updateService: (id, updates) => set((state) => ({
    services: state.services.map((s) =>
      s.id === id ? { ...s, ...updates } : s
    ),
    selectedService: state.selectedService?.id === id
      ? { ...state.selectedService, ...updates }
      : state.selectedService,
  })),

  removeService: (id) => set((state) => ({
    services: state.services.filter((s) => s.id !== id),
    selectedService: state.selectedService?.id === id ? null : state.selectedService,
  })),

  setSelectedService: (service) => set({ selectedService: service }),
}));
